// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"9ac95311","368":"746df082","497":"86770a12","641":"f8ed5d26","970":"00252342"}[chunkId] + ".chunk.js";
};